import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import { Button } from '@/components/ui/button';
import { Tabs, TabsContent, TabsList, TabsTrigger } from '@/components/ui/tabs';
import { toast } from 'sonner';
import { LogOut, Plus } from 'lucide-react';
import CategoryManager from '@/components/admin/CategoryManager';
import ProductManager from '@/components/admin/ProductManager';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const AdminDashboard = () => {
  const navigate = useNavigate();
  const [token, setToken] = useState('');
  
  useEffect(() => {
    const savedToken = localStorage.getItem('bozs-admin-token');
    if (!savedToken) {
      navigate('/admin');
      return;
    }
    setToken(savedToken);
  }, [navigate]);

  const handleLogout = async () => {
    try {
      await axios.post(`${API}/admin/logout`, {}, {
        headers: { Authorization: `Bearer ${token}` }
      });
    } catch (error) {
      console.error('Logout error:', error);
    } finally {
      localStorage.removeItem('bozs-admin-token');
      toast.success('Çıkış yapıldı');
      navigate('/admin');
    }
  };

  if (!token) return null;

  return (
    <div className="min-h-screen" style={{ background: '#faf8f5' }}>
      {/* Header */}
      <header className="border-b" style={{ background: 'white', borderColor: '#e6ddd3' }}>
        <div className="container mx-auto px-4 py-4 flex items-center justify-between">
          <h1 className="text-2xl font-bold" style={{ color: '#2d1f14' }}>BOZ'S Admin</h1>
          <Button
            variant="outline"
            onClick={handleLogout}
            className="flex items-center gap-2"
            data-testid="admin-logout-button"
          >
            <LogOut className="h-4 w-4" />
            Çıkış Yap
          </Button>
        </div>
      </header>

      {/* Main Content */}
      <main className="container mx-auto px-4 py-8">
        <Tabs defaultValue="categories" className="w-full">
          <TabsList className="grid w-full max-w-md grid-cols-2">
            <TabsTrigger value="categories" data-testid="categories-tab">Kategoriler</TabsTrigger>
            <TabsTrigger value="products" data-testid="products-tab">Ürünler</TabsTrigger>
          </TabsList>

          <TabsContent value="categories" className="mt-6">
            <CategoryManager token={token} />
          </TabsContent>

          <TabsContent value="products" className="mt-6">
            <ProductManager token={token} />
          </TabsContent>
        </Tabs>
      </main>
    </div>
  );
};

export default AdminDashboard;
